import React, { useContext, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import yup from '../../libs/yup/yup';
import CustomInput from '../../components/input/CustomInput';
import { signinAdmin } from '../../api/sportaloka-client';
import { AuthContext } from '../../context/AuthProvider';
import { Link } from 'react-router-dom';

const defaultValues = {
  email: '',
  password: ''
};

const schema = yup.object().shape({
  email: yup
    .string()
    .label('Alamat email')
    .email('Format alamat email salah')
    .required('${label} wajib diisi'),
  password: yup.string().label('Kata sandi').required('${label} wajib diisi')
});

function Signin() {
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useContext(AuthContext);

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    try {
      setLoading(true);
      if (!localStorage.getItem('accessToken')) {
        const response = await signinAdmin({
          email: val.email,
          password: val.password
        });
        const responseData = response.data.data;
        dispatch({
          type: 'SIGNIN',
          payload: {
            accessToken: 'Bearer ' + responseData.access_token,
            refreshToken: responseData.refresh_token,
            userProfile: responseData.user,
            sessionId: responseData.user.session_id
          }
        });
      } else {
        window.location.reload();
      }
    } catch (error) {
      const errorStatus = error.response?.status;
      if (errorStatus === 400) {
        Swal.fire({
          title: 'Gagal!',
          text: 'Kombinasi email dan kata sandi tidak cocok',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row justify-content-center align-items-center w-100">
      <div className="col-12 col-sm-10 col-md-6 col-lg-4">
        <div className="py-30 px-30 rounded-4 bg-white shadow-3 mt-20 w-100">
          <form className="row y-gap-20" onSubmit={handleSubmit(onSubmit)}>
            <div className="col-12 text-center">
              <img src="/img/general/SP2_logo_black.png" className="h-50" alt="logo icon" />
              <h4 className="text-18 m-2 fw-400">Silakan masuk untuk melanjutkan</h4>
            </div>

            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, onBlur, value } }) => (
                <div className="col-12">
                  <CustomInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    type="text"
                    label="Alamat Email"
                    isError={Boolean(errors.email)}
                    errorMessage={Boolean(errors.email) && errors.email.message}
                  />
                </div>
              )}
            />

            <Controller
              control={control}
              name="password"
              render={({ field: { onChange, onBlur, value } }) => (
                <div className="col-12">
                  <CustomInput
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    autoComplete="off"
                    type="password"
                    label="Kata Sandi"
                    isError={Boolean(errors.password)}
                    errorMessage={Boolean(errors.password) && errors.password.message}
                  />
                </div>
              )}
            />

            <div className="col-12">
              <button
                disabled={loading}
                type="submit"
                className="button py-20 -dark-1 bg-blue-1 text-white w-100">
                {loading ? 'Mohon tunggu...' : 'Masuk'}
                {!loading && <div className="icon-arrow-top-right ml-15" />}
              </button>
            </div>

            <div className="col-12 text-center">
              <Link
                to="/forgot-password"
                className="text-14 fw-500 text-blue-1 underline text-center">
                Lupa kata sandi anda?
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Signin;
